const aboutData = {
    aim: "The primary objective of the Computer Science & Engineering programme is to hone the technical skills expected from today's engineering professionals by providing a sound technical platform and the required knowledge base. The programme aims to provide specialization in a wide range of hardware and software subjects in order to bridge the gap between knowledge and its practical application thus producing an ideal software engineer. ",
    vision: 'Evolve into a centre of excellence to serve the emerging knowledge society.',
    mission: [
        {
            id: 'M1',
            m: 'Impart quality education to the graduate and undergraduate students in Computer Science and Engineering.',
        },
        {
            id: 'M2',
            m: 'Inculcate students with technical knowledge and human values to create socially committed Engineers.',
        },
        {
            id: 'M3',
            m: 'Empower the students to succeed in innovative research and developments to serve the computational needs of the society.',
        },
        
    ]
}


export default aboutData